<form *ngIf="!!form" [formGroup]="form">
  <div class="panel-group schema-form-panel" id="accordion" role="tablist" aria-multiselectable="true">
    <ng-template ngFor let-group [ngForOf]="groups" let-groupIndex="index" let-isFirst="first">
      <div
        *ngIf="!(group.hiddenObs | async)"
        [ngClass]="group.groupClass"
        class="panel form-group-block"
        [attr.data-form-group-id]="group.id"
        [attr.data-is-active-group]="groupIndex === currentOpenPage"
        [class.panel-default]="!!group.name"
        [class.disabled]="group.disabledObs && (group.disabledObs | async)"
      >
        <div
          *ngIf="group.name"
          class="panel-heading darker-panel"
          role="tab"
          [attr.id]="'heading' + getUniqueGroupId(group, groupIndex)"
          (click)="handlePageHeaderClick(groupIndex)"
          data-toggle="collapse"
          data-parent="#accordion"
          [attr.href]="'#collapse' + getUniqueGroupId(group, groupIndex)"
          [attr.aria-controls]="'collapse' + getUniqueGroupId(group, groupIndex)"
          data-e2e-id="panel-heading"
        >
          <h4 class="panel-title">
            <a role="button">
              {{ group.name }}
              <i
                class="glyphicon fl-right"
                [ngClass]="{
                  'glyphicon-triangle-bottom': groupIndex === currentOpenPage,
                  'glyphicon-triangle-right': groupIndex !== currentOpenPage
                }"
              ></i>
            </a>
          </h4>
        </div>
        <div
          [attr.id]="'collapse' + getUniqueGroupId(group, groupIndex)"
          class="tabpanel panel-collapse collapse"
          [class.in]="groupIndex === currentPage"
          role="tabpanel"
          [attr.aria-labelledby]="'heading' + getUniqueGroupId(group, groupIndex)"
          data-e2e-id="tabpanel"
        >
          <div class="panel-body">
            <xvi-schema-form-group [group]="group"></xvi-schema-form-group>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</form>
